import React from 'react'
import { useTranslation } from 'react-i18next'
import CopyButton from '../components/CopyButton';
import NextSectionCard from '../components/NextSectionCard';
import { timeSince } from '../utils/timeSince';
import PreviousSectionCard from '../components/PreviousSectionCard';
import caseIcon from "../assets/icons/case.svg";
import { Trans } from "react-i18next";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import step2 from "../assets/image/word/step2.png";
import step4 from "../assets/image/word/step4.png";
import step7 from "../assets/image/word/step7.png";
import step8 from "../assets/image/word/step8.png";
import step9 from "../assets/image/word/step9.png";
import step10 from "../assets/image/word/step10.png";
import step11a from "../assets/image/word/step11a.png";
import step11b from "../assets/image/word/step11b.png";
import step12a from "../assets/image/word/step12a.png";
import step12b from "../assets/image/word/step12b.png";

const Word = () => {
    const { t, i18n } = useTranslation();
    const lastUpdated = "2026-03-18";
    const lang = i18n.language;

    const buildCopyText = (t) => {
        return [
            t("sidebar.cases.word"),
            "",
            t("word.step1"),
            `- ${t("word.step1a")}`,
            `- ${t("word.step1b")}`,
            "",
            t("word.step2"),
            t("word.step3"),
            t("word.step4"),
            t("word.step5"),
            t("word.step6"),
            t("word.step7"),
            t("word.step8"),
            "",
            t("word.step9"),
            `- ${t("word.step9a")}`,
            `- ${t("word.step9b")}`,
            `- ${t("word.step9c")}`,
            `- ${t("word.step9d")}`,
            `- ${t("word.step9e")}`,
            `- ${t("word.step9f")}`,
            "",
            t("word.step10"),
            `- ${t("word.step10a")}`,
            "",
            t("word.step11"),
            "",
            t("word.step12"),
            t("word.step12des"),
            `- ${t("word.step12a")}`,
            `- ${t("word.step12b")}`,
            `- ${t("word.step12c")}`,
            `- ${t("word.step12d")}`,
        ].join("\n");
    };
    return (
        <div className="text-black dark:text-white">
            <div
                className="
          desktop:px-4
          py-3
          max-w-3xl
        "
            >
                <div className="relative flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <div>
                            <img src={caseIcon} alt="case" className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-[16px] tabletpro:text-[12px] mini_mobile:text-[14px] text-[#0087FE] font-normal">
                                {t("sidebar.cases.title").toUpperCase()}
                            </p>
                        </div>
                    </div>

                    <CopyButton text={buildCopyText(t)} />
                </div>

                <div className="mt-2 relative">
                    <section className='flex gap-4'>
                        <p className='text-[#020617] dark:text-[#F8FAFC] text-[40px] tabletpro:text-[22px] mobile:text-[30px] mini_mobile:text-[24px] font-semibold'>{t("sidebar.cases.word")}</p>
                    </section>

                    <section className='flex flex-col gap-4 mt-1'>
                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step1"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("word.step1a")}
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                {t("word.step1b")}
                            </li>
                        </ul>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step2"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step2

                        }}>
                            <img
                                src={step2}
                                alt="step2"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step3"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step4"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step4

                        }}>
                            <img
                                src={step4}
                                alt="step4"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step5"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step6"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step7"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step7

                        }}>
                            <img
                                src={step7}
                                alt="step7"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step8"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step8

                        }}>
                            <img
                                src={step8}
                                alt="step8"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step9"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step9a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step9b"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step9c"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="list-none text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step9d"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step9e"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step9f"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step9

                        }}>
                            <img
                                src={step9}
                                alt="step9"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step10"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step10a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step10

                        }}>
                            <img
                                src={step10}
                                alt="step10"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step11"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step11a

                        }}>
                            <img
                                src={step11a}
                                alt="step11a"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step11b

                        }}>
                            <img
                                src={step11b}
                                alt="step11b"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step12"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <p className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                            <Trans
                                i18nKey="word.step12des"
                                components={{
                                    strong: <span className="font-semibold" />,
                                }}
                            />
                        </p>

                        <ul className="list-disc pl-6 space-y-1">
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step12a"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step12b"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step12c"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                            <li className="text-[16px] font-normal text-[#0F172A] dark:text-[#F1F5F9]">
                                <Trans
                                    i18nKey="word.step12d"
                                    components={{
                                        strong: <span className="font-semibold" />,
                                    }}
                                />
                            </li>
                        </ul>

                        <Zoom zoomMargin={80} zoomImg={{
                            src: step12a

                        }}>
                            <img
                                src={step12a}
                                alt="step12a"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>
                        <Zoom zoomMargin={80} zoomImg={{
                            src: step12b

                        }}>
                            <img
                                src={step12b}
                                alt="step12b"
                                className="max-w-full h-auto cursor-zoom-in mx-auto block"
                            />
                        </Zoom>
                    </section>

                    <section className='flex gap-4 mt-4 flex-col desktop:flex-row'>
                        <PreviousSectionCard
                            label={t("sidebar.cases.title")}
                            to="/usecase"
                        />
                        <NextSectionCard
                            label={t("sidebar.cases.excel")}
                            to="/cases/excel"
                        />
                    </section>

                    {/* Last updated */}
                    <section className='flex gap-4 mt-4'>
                        <span className="text-[14px] text-[#64748B]">
                            {t("welcome.lastUpdatedBase")} {timeSince(lastUpdated, lang)}
                        </span>
                    </section>
                </div>

            </div>
        </div>

    )
}

export default Word
